import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // List of all supported locales
  locales: ['en', 'tr'],

  // Default locale - English as primary
  defaultLocale: 'en',

  // Locale prefix configuration
  // RULE 15: Always show locale prefix for consistent routing
  // as-needed mode causes 404 for /login (only /en/login works)
  // always mode ensures /login redirects to /en/login properly
  localePrefix: 'always',
});
